module.exports = __webpack_public_path__ + "assets/img/wu.fb286835.png";